import {useEffect, useState} from 'react';
import {getIsServer} from '../utils/getIsServer';

export const useDocumentHeight = () => {
    const [documentHeight, setDocumentHeight] = useState(() => {
        if (getIsServer()) {
            return 0;
        }
        return document.body.scrollHeight;
    });

    useEffect(() => {
        const updateHeight = () => {
            setDocumentHeight(document.body.scrollHeight);
        };

        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(document.body);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return documentHeight;
};
